/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */
const WORKFLOW_2_2 = {
    "type": "FeatureCollection",
    "features": [
        {
            "type": "Feature",
            "properties": { areaName: "Area 1", },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [-67.74474728413105, 16.972877878958986],
                        [-179.9, 16.972877878958986],
                        [-179.9, -50.95833659218356],
                        [-67.74474728413105, -50.95833659218356],
                        [-67.74474728413105, 16.972877878958986]
                    ]
                ]
            },
        }
    ]
};

export default WORKFLOW_2_2